"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupClientState = exports.setDesktopType = exports.genFakeWebopResponse = exports.genFakeAxiosResponse = exports.defaultTestSetup = exports.TEST_VERSION = exports.TEST_SESSION_KEY = exports.TEST_SESSION_ID = exports.TEST_PUBLISH_KEY = exports.TEST_EMBED_DATA = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var TEST_SESSION_KEY = "testSessionKey";
exports.TEST_SESSION_KEY = TEST_SESSION_KEY;
var TEST_SESSION_ID = "testSessionID";
exports.TEST_SESSION_ID = TEST_SESSION_ID;
var TEST_VERSION = "testVersion";
exports.TEST_VERSION = TEST_VERSION;
var TEST_PUBLISH_KEY = "testPublishKey";
exports.TEST_PUBLISH_KEY = TEST_PUBLISH_KEY;
var TEST_EMBED_DATA = "testEmbedData";

/**
 * Sets up a spoofed client state on the window. This is necessary
 * for generating request configs.
 * @param clientStateProps overrides for client state properties
 */
exports.TEST_EMBED_DATA = TEST_EMBED_DATA;
var setupClientState = function setupClientState() {
  var clientStateProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  window.clientState = (0, _objectSpread2.default)({
    sessionKey: TEST_SESSION_KEY,
    version: TEST_VERSION
  }, clientStateProps);
};

/**
 * Spoofs jscDesktop's desktopType property on the window.
 * This is necessary for generating request configs.
 * @param type A desktop type number, defaults to a number that forces "home"
 */
exports.setupClientState = setupClientState;
var setDesktopType = function setDesktopType() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8989;
  window.jscDesktop = {
    desktopType: type
  };
};

/**
 * This function dumps the necessary properties on the window for request config generation.
 * If you want more granular control over test setup, use `setupClientState` and `setDesktopType`
 */
exports.setDesktopType = setDesktopType;
var defaultTestSetup = function defaultTestSetup() {
  setupClientState();
  setDesktopType();
};

/**
 * Generates a fake axios response object and allows you to override any property you want for testing.
 * @param data The data property of the axios response object
 * @param config The request config you are using. Plug yours in for the most realistic results.
 * @param overrides Object of overrides for any property you want to control in the axios response
 */
exports.defaultTestSetup = defaultTestSetup;
var genFakeAxiosResponse = function genFakeAxiosResponse(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var overrides = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _objectSpread2.default)({
    data: data,
    statusText: "success - fake response",
    status: 200,
    config: config,
    headers: {}
  }, overrides);
};

/**
 * Generates a fake webop response object. This can be passed to `genFakeAxiosResponse` to build a full axios webop response
 * @param data The data to put inside of the webop response
 * @param overrides Object of overrides for any property you want to control in the webop response body
 */
exports.genFakeAxiosResponse = genFakeAxiosResponse;
var genFakeWebopResponse = function genFakeWebopResponse(data, overrides) {
  return (0, _objectSpread2.default)({
    data: data,
    errors: [],
    errorCode: 0,
    serverStatus: true,
    serverStatusText: "success - fake response",
    isLicensingError: false,
    success: true
  }, overrides);
};
exports.genFakeWebopResponse = genFakeWebopResponse;
//# sourceMappingURL=testUtils.js.map